import { render, staticRenderFns } from "./StorageSpaceInfo.vue?vue&type=template&id=65e789ad&"
import script from "./StorageSpaceInfo.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports